import {FC} from "react";

import IconBatteryRed from "../../../assets/icons/battery-red.svg";
import IconBatteryYelow from "../../../assets/icons/battery-yellow.svg";
import IconBatteryGreen from "../../../assets/icons/battery-green.svg";
import {TBattery} from "../../../pages/Dashboard/Dashboard.type";

interface IProps {
  batteryRussia: TBattery;
  batteryWorld: TBattery;
  type: "tehnologie" | "cluster";
}

export const SideBarContentMapBattery: FC<IProps> = ({
  batteryRussia,
  batteryWorld,
  type,
}) => {
  const getBatteryIcon = (battery: TBattery) => {
    switch (battery) {
      case "Внедрение":
        return IconBatteryGreen;
      case "Прототип":
        return IconBatteryYelow;
      case "Концепт":
      default:
        return IconBatteryRed;
    }
  };

  const getBatteryText = (battery: TBattery) => {
    return battery;
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          color: "white",
        }}
      >
        <div style={{display: "flex", alignItems: "center", gap: 10}}>
          <img
            src={getBatteryIcon(batteryRussia)}
            alt=""
            width={16}
            height={20}
          />
          <span>
            Зрелость {type === "tehnologie" ? "технологии" : "кластера"} в
            России
          </span>
        </div>
        <div>{getBatteryText(batteryRussia)}</div>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          color: "white",
        }}
      >
        <div style={{display: "flex", alignItems: "center", gap: 10}}>
          <img
            src={getBatteryIcon(batteryWorld)}
            alt=""
            width={16}
            height={20}
          />
          <span>
            Зрелость {type === "tehnologie" ? "технологии" : "кластера"} в мире
          </span>
        </div>
        <div>{getBatteryText(batteryWorld)}</div>
      </div>
    </>
  );
};
